import { Component, OnInit } from '@angular/core';
import { DzModalConfig, DzModalService } from '@blk/daisy/modules/modals';
import { ErrorDCR } from '@ddt-web/config';
import { UpdatePreferenceResponse } from '@ddt-web/data-service';
import { ApplicationStateStoreProxyService, PartnerAcknowledgement, PartnerPlatform } from '@ddt-web/shared-stores';
import { UrlRedirectService } from '@ddt-web/url';
import { take } from 'rxjs/operators';

import { PartnerAcknowledgementService } from '../../services/partner-acknowledgement.service';

@Component({
	templateUrl: './partner-acknowledgment-dialog.component.html',
	styleUrls: ['./partner-acknowledgment-dialog.component.scss']
})
export class PartnerAcknowledgementDialogComponent implements OnInit {
	public selectedPartner: PartnerPlatform = null;
	public partnerAcknowledgement: PartnerAcknowledgement;
	public isSavingAcknowledgement: boolean = false;

	constructor(
		private config: DzModalConfig,
		private dzModalService: DzModalService,
		private partnerAcknowledgementService: PartnerAcknowledgementService,
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService,
		private urlRedirectService: UrlRedirectService
	) { }

	public ngOnInit(): void {
		this.partnerAcknowledgement = this.config.contentData.partnerAcknowledgement;
		this.selectedPartner = this.config.contentData.selectedPartner;
	}

	public storeUserAcknowledgement(): void {
		this.isSavingAcknowledgement = true;
		const currentAcknowledgementHash = this.partnerAcknowledgement[this.selectedPartner.id].currentAcknowledgementMsgHash;
		this.partnerAcknowledgementService.storeUserAcknowledgement(
			currentAcknowledgementHash,
			this.selectedPartner?.id
		)
			.pipe(take(1))
			.subscribe({
				next: (response: UpdatePreferenceResponse) => {
					if (!response.success) {
						this.isSavingAcknowledgement = false;
						this.dzModalService.closeAll();
						console.error('An API error occurred while saving acknowledgement');
						throw new Error(ErrorDCR.SOMETHING_WRONG_ERROR_TITLE);
					} else {
						this.isSavingAcknowledgement = false;
						const acknowledgementDetails = {
							currentAcknowledgementMsgHash: currentAcknowledgementHash,
							lastUserAcknowledgedMsgHash: currentAcknowledgementHash,
							isUserAcknowledgementRequired: false
						};
						this.applicationStateStoreProxyService.updatePartnerAcknowledgementState({
							[this.selectedPartner.id]: acknowledgementDetails
						});

						this.dzModalService.closeAll();
					}
				},
				error: (error) => {
					this.isSavingAcknowledgement = false;
					this.dzModalService.closeAll();
					console.error('An API error occurred while saving acknowledgement', error);
					throw new Error(error);
				}
			});
	}

	public onDecline(): void {
		this.urlRedirectService.redirectToNewAnalysisPage();
		this.isSavingAcknowledgement = false;
		this.dzModalService.closeAll();
	}
}
